
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"external-link_svg__a","maskUnits":"userSpaceOnUse","x":"4","y":"4","width":"16","height":"16"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.431 14.984a.365.365 0 000 .497l.157.166c.13.137.341.137.472 0l8.976-9.467.02.02-.01 2.636c0 .194.15.351.333.351h.278a.343.343 0 00.334-.351L20 4.852a.343.343 0 00-.333-.352l-3.778.01a.343.343 0 00-.333.352v.293c0 .194.149.351.333.351l2.499-.01.02.02-8.977 9.468zm6.222-3.828l.222-.234c.21-.222.57-.065.57.248v6.924c0 .776-.598 1.406-1.334 1.406H5.333C4.597 19.5 4 18.87 4 18.094V7.78c0-.776.597-1.406 1.333-1.406H15c.297 0 .446.379.236.6l-.222.235a.325.325 0 01-.236.103H5.333a.457.457 0 00-.444.468v10.313c0 .259.199.468.444.468h9.778c.246 0 .445-.21.445-.468v-6.69c0-.093.035-.182.097-.248z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#external-link_svg__a)"}},[_c('path',{attrs:{"fill":"#FF5F3C","d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    